export const fieldTitles = {
    name: "Name",
    file_ext: "Data type",
    genome_build: "Genome build",
    file_size: "Size",
    update_time: "Date last updated (UTC)",
    date_uploaded: "Date uploaded (UTC)",
    uploaded_by: "Uploaded by",
    metadata_data_lines: "Data Lines",
    metadata_comment_lines: "Comment Lines",
    metadata_columns: "Number of Columns",
    metadata_column_types: "Column Types",
    message: "Message",
    misc_blurb: "Miscellaneous blurb",
    misc_info: "Miscellaneous information",
    tags: "Tags",
    uuid: "UUID",
};
